import { useState, useEffect, useRef } from 'react';
import { isString } from 'lodash';

export default function useWindowResizing(options) {
  const [isResizing, setIsResizing] = useState(false);
  const start = useRef(options?.start);
  const complete = useRef(options?.complete);
  const bodyClassName = useRef(
    isString(options) ? options : options?.bodyClassName
  );

  const delay = options?.delay ?? 150;

  useEffect(() => {
    if (isString(options)) {
      bodyClassName.current = options;
    } else {
      start.current = options?.start;
      complete.current = options?.complete;
      bodyClassName.current = options?.bodyClassName;
    }
  }, [options]);

  useEffect(() => {
    let windowIsResizing = false;
    let timer = null;

    const handler = () => {
      clearTimeout(timer);

      if (!windowIsResizing) {
        if (start.current) {
          start.current();
        }

        if (bodyClassName.current) {
          document.body.classList.add(bodyClassName.current);
        }

        setIsResizing(true);
      }

      windowIsResizing = true;

      timer = setTimeout(() => {
        requestAnimationFrame(() => {
          if (windowIsResizing) {
            windowIsResizing = false;
            setIsResizing(false);

            if (bodyClassName.current) {
              document.body.classList.remove(bodyClassName.current);
            }

            if (complete.current) {
              complete.current();
            }
          }
        });
      }, delay);
    };

    window.addEventListener('resize', handler);

    return () => {
      clearTimeout(timer);
      window.removeEventListener('resize', handler);
    };
  }, [delay]);

  return isResizing;
}
